<script setup>
import { useLocationStore } from "@/stores/locations"
import _ from "lodash"
import { ref } from "vue"

const mainStore = useLocationStore()
const filteredData = ref([])

const optSort = [
  { value: 0, label: "Newest First" },
  { value: 1, label: "Oldest First" },
  { value: 2, label: "Largest First" },
  { value: 3, label: "Smallest First" },
]
const optMag = [
  { value: [8, 99], label: "8+" },
  { value: [7, 7.9], label: "7.0 - 7.9" },
  { value: [6.1, 6.9], label: "6.1 - 6.9" },
  { value: [5.5, 6.0], label: "5.5 - 6.0" },
  { value: [2.5, 5.4], label: "2.5 - 5.4" },
  { value: [-99, 2.4], label: "< 2.5" },
]

const onChange = (e, v) => {
  // console.time("onChange")
  mainStore.isLoading = true
  let filteredDataValue = filteredData.value
  let index = 0
  index = e.target.value

  if (v === "mag" && index > 0) {
    filteredDataValue = _.filter(mainStore.locations, (d) => {
      let bool = false
      const m = optMag[index]
      if (d.properties.mag !== null) {
        const magVal = Number(d.properties.mag.toFixed(1))
        if (m.value[0] <= magVal && m.value[1] >= magVal) {
          bool = true
        }
      }
      return bool
    })
  } else if (v === "mag" && index < 0) {
    filteredDataValue = _.filter(mainStore.locations, () => true)
  } else if (v === "sort") {
    switch (index) {
      case "0":
        filteredDataValue = _.orderBy(filteredData.value, (d) => d.properties.time, "desc")
        break
      case "1":
        filteredDataValue = _.orderBy(filteredData.value, (d) => d.properties.time, "asc")
        break
      case "2":
        filteredDataValue = _.orderBy(filteredData.value, (d) => d.properties.mag, "desc")
        break
      case "3":
        filteredDataValue = _.orderBy(filteredData.value, (d) => d.properties.mag, "asc")
        break
      default:
    }
  }
  filteredData.value = filteredDataValue
  mainStore.filteredData = filteredData.value
  mainStore.isLoading = false
  // console.timeEnd("onChange")
}

const clickList = (loc) => {
  mainStore.selectedLocation = loc
}
</script>

<template>
  <div id="eqlist">
    <h5>Earthquakes, Past Day</h5>
    <span>{{ mainStore.filteredData.length }}</span>
    <span> earthquakes</span>
    <div class="d-flex flex-row gap-1">
      <select class="form-select" @change="onChange($event, 'mag')">
        <option value="-1">Filter by Magnitude</option>
        <option v-for="(m, index) in optMag" :key="index" :value="index">
          {{ m.label }}
        </option>
      </select>
      <select class="form-select" @change="onChange($event, 'sort')">
        <option value="-1">Sort By</option>
        <option v-for="(s, index) in optSort" :key="index" :value="index">
          {{ s.label }}
        </option>
      </select>
    </div>
    <ul v-if="!mainStore.isLoading" class="list-group fs-14">
      <li
        v-for="(location, index) in mainStore.filteredData"
        :key="index"
        class="list-group-item p-1"
        @click="clickList(location)"
      >
        <div class="d-flex flex-row gap-1">
          <span class="text-center px-1 w-10">{{ location.properties.mag }}</span>
          <span>{{ location.properties.place }}</span>
        </div>
      </li>
    </ul>
    <ul v-if="mainStore.isLoading" class="list-group">
      <li v-for="i in 15" :key="i" class="list-group-item p-1">
        <div class="d-flex flex-row gap-1">
          <span class="skeleton skeleton-text text-center px-1 w-10"></span>
          <span class="skeleton skeleton-text"></span>
        </div>
      </li>
    </ul>
  </div>
</template>
